<template>
	<UserPageLayout :loading="loading" :error="error">
		<div class="markdown-content" v-html="renderedMarkdown"></div>
	</UserPageLayout>
</template>

<script>
import UserPageLayout from './_PageLayout.vue'
import { marked } from 'marked'

export default {
	name: 'Instruction',
	components: {
		UserPageLayout
	},
	data() {
		return {
			loading: true,
			error: '',
			markdownContent: ''
		}
	},
	async mounted() {
		await this.fetchInstruction()
	},
	computed: {
		renderedMarkdown() {
			if (!this.markdownContent) return ''
			return marked(this.markdownContent)
		}
	},
	methods: {
		async fetchInstruction() {
			this.loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			if (!authToken || authToken === 'null') {
				this.$router.push({ name: 'Login' })
				return
			}

			try {
				const response = await this.$api.post('/api/user/instruction', {
					authToken: authToken
				})
				this.markdownContent = response.data.content || ''
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else {
					this.error = 'An error occurred while loading instructions.'
					console.error('Error:', error)
				}
			} finally {
				this.loading = false
			}
		}
	}
}
</script>

<style scoped>
.markdown-content {
	text-align: left;
	padding: 20px;
	line-height: 1.6;
}

</style>

